import { useEffect } from 'react';
import useWindowWidth from './useWindowWidth';

const useDisableBodyScroll = (isDisabled?: boolean): void => {
  const width = useWindowWidth();
  const body = document.querySelector('body');
  useEffect(() => {
    if (body) {
      body.style.overflow = isDisabled ? 'hidden' : '';
    }
  }, [body, isDisabled]);
  useEffect(() => {
    if (width >= 1280 && isDisabled && body) {
      body.style.overflow = '';
    }
  }, [body, isDisabled, width]);
};

export default useDisableBodyScroll;
